import { IWatchlistable } from 'src/components/filmwebid/withWatchlistState';
import WatchlistSvg from 'src/components/svg/WatchlistSvg';
import theme from 'src/components/themes/DefaultTheme';
import styled from 'src/lib/styles/css';

//#region [Props]
type WatchlistActionButtonProps = {
	className?: string;
	hideLabel?: boolean;
} & IWatchlistable;
//#endregion

//#region [Component]
export default function WatchlistActionButton({ className, isWatchlisted, onWatchlistClick, hideLabel = false }: WatchlistActionButtonProps) {
	return <SButton className={className} onClick={onWatchlistClick} title='Legg filmen i huskelisten'>
		<SWatchlistSvg selected={isWatchlisted} /> {!hideLabel && <SWatchListLabel>Watchlist</SWatchListLabel>}
	</SButton>;
}
//#endregion

//#region [Styles]
const SButton = styled.button`
	height: 25px;
	background-color: var(--textcolor);
	border: none;
	border-radius: 4px;
	width: 100%;
	color: var(--buttoncolor);
	font-size: 12px;
	font-weight: 510;

	@media (min-width: 550px) {
        /*@media (orientation: landscape) {*/
        height: 28px;
        font-size: 13px;
    }
`;

const SWatchlistSvg = styled(WatchlistSvg)`
	display: inline-block;
	width: 0.8em;

	vertical-align: middle;

	path {
		fill: currentColor;
	}
`;

const SWatchListLabel = styled.span`
	margin-left: 1ch;
`;
//#endregion